import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export const ICON_SIZES = {
  xs: "h-3 w-3",
  sm: "h-3.5 w-3.5",
  md: "h-4 w-4",
  lg: "h-6 w-6",
  xl: "h-10 w-10",
} as const;

export type LucideIconSize = keyof typeof ICON_SIZES;

export interface LucideIconV2Props {
  readonly icon: LucideIcon;
  readonly size?: LucideIconSize;
  readonly className?: string;
  readonly "aria-label"?: string;
}

export function LucideIconV2({
  icon: Icon,
  size = "md",
  className,
  "aria-label": ariaLabel,
}: LucideIconV2Props) {
  return (
    <Icon
      className={cn(ICON_SIZES[size], "shrink-0", className)}
      aria-hidden={ariaLabel ? undefined : true}
      aria-label={ariaLabel}
    />
  );
}
